var map = {
	"./de": 14,
	"./de.js": 14,
	"./en": 15,
	"./en.js": 15,
	"./es": 16,
	"./es.js": 16,
	"./et": 17,
	"./et.js": 17,
	"./fr": 18,
	"./fr.js": 18,
	"./lv": 19,
	"./lv.js": 19,
	"./ru": 20,
	"./ru.js": 20,
	"./uk": 21,
	"./uk.js": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;